import React from "react"

import { ThemeProvider } from "@mui/material"

import { ComponentWithChildren } from "@cirrus/core/decorators"
import * as Theme from "@cirrus/ui-kit/src/lib/theme"
import { MuiButtonBase } from "./Theme/MuiButtonBase"
import { MuiTextField } from "./Theme/MuiTextField"

export const ThemeProviderDecorator: ComponentWithChildren = ({ children }) => {

  const themeBase = Theme.from()
  const theme = {
    ...themeBase,
    components: {
      ...themeBase.components,
      MuiButtonBase,
      MuiTextField,
    }
  }

  console.debug("[theme]", {theme})
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  )
}
